import { useContext } from 'react';
import AsyncContext from 'context/AsyncContext';

const useAsync = () => {
  const { loading, errors } = useContext(AsyncContext);
  return { loading, errors };
};

export default useAsync;
